module.exports = __webpack_public_path__ + "img/expire-tag.84c24f6a.png";